import { Inject, Injectable } from '@angular/core';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { HttpHelper } from '@app/common/http-helper';
import { TrendingResult } from '@app/common/trending-result';
import { SearchPostQuery, SearchPostQueryRequest } from '@app/models/search-post-query';
import { SearchResult } from '@app/models/search-result';
import { SearchService } from '@app/services/search.service';
import { Environment } from '@environments/interface.environment';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';

@Injectable({
  providedIn: 'root'
})
export class EditorTrendingNewsService {

  constructor(private searchService: SearchService,
              @Inject(CUSTOMERENVIRONMENT) private environment: Environment,
              private featureSettingsStoreService: FeatureSettingsStoreService,
              private httpHelper: HttpHelper) { }

  getTrendingNews(newsCount): Observable<Array<SearchResult>> {

    const limitPath = this.featureSettingsStoreService.state.trendingResult === TrendingResult.ModernOnlyFromCoreRootSite ? 'AND (path:' + encodeURI(this.environment.coreWorkplaceSiteUrl) + ')' : '';
    const query = 'ContentTypeId:0x0101009D1CB255DA76424F860D91F20E6C4118* AND PromotedState=2' + ' ' + limitPath;

    const postQuery = new SearchPostQuery({
      request: new SearchPostQueryRequest({
        Querytext: query,
        RowLimit: newsCount,
        EnableSorting: true,
        TrimDuplicates: false,
        SortList: [
          {
            'Property': 'ViewsLifeTime',
            'Direction': 1
          }
        ],
        SelectProperties: [
          'ContentType',
          'ContentTypeId',
          'Title',
          'EditorOwsUser',
          'ModifiedBy',
          'LastModifiedBy',
          'Path',
          'PictureThumbnailURL',
          'LastModifiedTime',
          'FirstPublishedDate',
        ],
        Properties: [
          {
            Name: 'EnableDynamicGroups',
            Value: {
              BoolVal: 'True',
              QueryPropertyValueTypeIndex: 3
            }
          } // include results form private groups - https://www.techmikael.com/2017/01/retrieving-search-results-from-private.html
        ]
      })
    });

    return this.searchService.sendPostSearchQuery(postQuery)
      .pipe(
        map(data => {
          console.log(`getTrendingNews: fetched results by search: `);
          console.log(data);
          return data;
        }),
        catchError(this.httpHelper.handleError({ operation: 'getTop10TrendingNews', result: new Array<SearchResult>() })));
  }

  getTrendingPages(pageCount): Observable<Array<SearchResult>> {

    const limitPath = this.featureSettingsStoreService.state.trendingResult === TrendingResult.ModernOnlyFromCoreRootSite ? 'AND (path:' + encodeURI(this.environment.coreWorkplaceSiteUrl) + ')' : '';
    const query = 'contentclass:STS_ListItem_WebPageLibrary AND (ContentTypeId:0x0101009D1CB255DA76424F860D91F20E6C4118* AND PromotedState:0)' + ' ' + limitPath;

    const postQuery = new SearchPostQuery({
      request: new SearchPostQueryRequest({
        Querytext: query,
        RowLimit: pageCount,
        EnableSorting: true,
        TrimDuplicates: false,
        SortList: [
          {
            'Property': 'FirstPublishedDate',
            'Direction': 1
          }
        ],
        SelectProperties: [
          'ContentType',
          'ContentTypeId',
          'Title',
          'EditorOwsUser',
          'ModifiedBy',
          'LastModifiedBy',
          'Path',
          'PictureThumbnailURL',
          'LastModifiedTime',
          'FirstPublishedDate',
        ],
        Properties: [
          {
            Name: 'EnableDynamicGroups',
            Value: {
              BoolVal: 'True',
              QueryPropertyValueTypeIndex: 3
            }
          } // include results form private groups - https://www.techmikael.com/2017/01/retrieving-search-results-from-private.html
        ]
      })
    });

    return this.searchService.sendPostSearchQuery(postQuery)
      .pipe(
        map(data => {
          console.log(`getTrendingPages: fetched results by search: `);
          console.log(data);
          return data;
        }),
        catchError(this.httpHelper.handleError({ operation: 'getTop10TrendingPages', result: new Array<SearchResult>() })));
  }
}
